import React, { ForwardedRef, forwardRef, useContext, useState } from 'react';
import Image from 'next/image';
import Button from 'components/Button';
import { AnswerCardProps } from 'views/Questions/components/AnswerCard/AnswerCard.types';
import dateInterval from 'utils/dateInterval';
import sendReportHandler from 'views/Questions/utils/sendReportHandler';
import showNotification from 'utils/showNotification';
import { appAuthContext } from 'context/AuthContext';
import postVoteAnswer from '../../api/postVoteAnswer';
import styles from './AnswerCard.module.css';

const AnswerCard = forwardRef(
  ({ answerData }: AnswerCardProps, ref: ForwardedRef<HTMLDivElement | null>) => {
    // TODO: редактирование текста ответа
    const { user } = useContext(appAuthContext);
    const {
      id,
      body,
      updatedAt,
      userIsAuthor,
      autorName,
      autorAvatar,
      likesCount,
      alreadyVoted,
    } = answerData;

    const [answerLikes, setAnswerLikes] = useState(likesCount);
    const [userVoted, setUserVoted] = useState(alreadyVoted || userIsAuthor);

    const voteForAnswerHandler = async () => {
      if (userVoted) return;

      if (!user) {
        return showNotification(
          'info',
          'Чтобы поблагодарить автора ответа, войди или зарегистрируйся',
        );
      }

      const postVoteData = await postVoteAnswer(id);
      if (postVoteData.success && postVoteData?.rating) {
        setAnswerLikes(postVoteData.rating);
        setUserVoted(true);
      }
    };

    const submitReportHandler = async () => {
      if (!user) {
        return showNotification(
          'info',
          'Чтобы отправить жалобу, войди или зарегистрируйся',
        );
      }
      await sendReportHandler('answers', id);
    };

    return (
      <article className={styles.card} ref={ref}>
        <div className={styles.user}>
          <div className={styles.user__avatar}>
            <Image alt="Аватар" src={autorAvatar} width={32} height={32} />
          </div>
          <span
            className={`${styles.user__name} ${
              userIsAuthor ? styles.user__name_current : ''
            }`}
          >
            {autorName}
          </span>
          <span className={styles.user__date}>{dateInterval(updatedAt)}</span>
        </div>
        <div
          className={styles.card__content}
          dangerouslySetInnerHTML={{ __html: body }}
        />
        <div className={styles.card__controll}>
          <Button
            className={`${styles.thanks_btn} ${
              userVoted ? styles.thanks_btn_active : ''
            }`}
            text=""
            disabled={userVoted}
            onClick={() => voteForAnswerHandler()}
            type={'default'}
          >
            <>
              <span className={styles.thanks_btn__text}>Спасибо</span>
              <span className={styles.thanks_btn__counter}>{answerLikes}</span>
            </>
          </Button>
          {!userIsAuthor && (
            <Button
              className={styles.report_btn}
              text=""
              onClick={() => submitReportHandler()}
              type="transparent"
            >
              <Image
                alt="Пожаловаться"
                src="https://static.uchi.ru/files/otvety/report_flag.svg"
                width={24}
                height={24}
              />
            </Button>
          )}
        </div>
      </article>
    );
  },
);

AnswerCard.displayName = 'AnswerCard';

export default AnswerCard;
